import React from 'react';
import PropTypes from 'prop-types';
import * as Headless from '@headlessui/react';
import clsx from 'clsx';

/**
 * A component that renders an error message element.
 *
 * @param {Object} props - The props for the component.
 * @param {string} [props.className] - Additional class names for the error message.
 * @param {Object} [props.children] - Child elements to be rendered inside the error message.
 * @returns {JSX.Element} The rendered error message component.
 */
export function ErrorMessage({ className, ...props }) {
  return (
    <Headless.Description
      data-slot="error"
      {...props}
      className={clsx(
        className,
        'text-base/6 text-red-600 data-[disabled]:opacity-50 sm:text-sm/6'
      )}
    />
  );
}

ErrorMessage.propTypes = {
  className: PropTypes.string,
};
